export default __webpack_public_path__ + "static/media/Rosewood Snare.e3c87f48.png";